// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"709":"79b9bada","805":"aff83442"}[chunkId] + ".css";
};